module.exports = __webpack_public_path__ + "img/fedex-gif2.372fc3ba.gif";